"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var icons_1 = require("../../../../icons");
var Text_1 = __importDefault(require("../../../Text"));
var FeaturedIcon_1 = __importDefault(require("../../../data-display/FeaturedIcon"));
var styles_1 = require("./styles");
var Link_1 = __importDefault(require("../../../Link"));
var variables_1 = require("../../../../style/variables");
var layout_1 = require("../../../layout");
var iconColor = {
    default: {
        color: 'Gray',
    },
    hovered: {
        color: 'Primary',
    },
};
var FileUploadDropArea = function (props) {
    var _a = props.disabled, disabled = _a === void 0 ? false : _a, multiple = props.multiple, addFiles = props.addFiles, _b = props.uploadUserMessage, uploadUserMessage = _b === void 0 ? '' : _b, accept = props.accept;
    var _c = react_2.useState(iconColor.default), uploadIconColor = _c[0], setUploadIconColor = _c[1];
    var handleFiles = function (inputFiles) {
        if (inputFiles && inputFiles.length) {
            var files = Array.from(inputFiles);
            addFiles(files);
        }
    };
    // handle drag events
    var handleDrag = function (e) {
        e.preventDefault();
    };
    // triggers when file is dropped
    var handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer.files && e.dataTransfer.files.length) {
            handleFiles(e.dataTransfer.files);
        }
    };
    // triggers when file is selected with click
    var handleChange = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.target.files && e.target.files.length) {
            handleFiles(e.target.files);
        }
    };
    var dragProps = disabled ? {} : { onDragOver: handleDrag, onDrop: handleDrop };
    var mainContaninerStyles = [
        styles_1.fileUploadDropAreaContainerStyleConfig.container,
        disabled ? styles_1.fileUploadDropAreaContainerStyleConfig.disabledContainer : undefined,
    ];
    var handleMouseEnter = function () {
        if (!disabled) {
            setUploadIconColor(function () { return iconColor.hovered; });
        }
    };
    var handleMouseLeave = function () {
        if (!disabled) {
            setUploadIconColor(function () { return iconColor.default; });
        }
    };
    var textBodyColor = disabled ? "var(" + variables_1.RootColor.Gray.LIGHT_1 + ")" : 'inherit';
    var linkColor = disabled ? "var(" + variables_1.TextColor.DISABLED + ")" : "var(" + variables_1.RootColor.Blue.DEFAULT + ")";
    return (react_1.jsx("label", __assign({ css: mainContaninerStyles, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, dragProps),
        react_1.jsx(layout_1.Flex, { css: { pointerEvents: disabled ? 'none' : 'all' }, direction: "column", alignItems: "center", justifyContent: "center", gap: 12 },
            react_1.jsx(FeaturedIcon_1.default, __assign({ icon: icons_1.UploadCloud, size: "md", theme: "light-circle-outline" }, uploadIconColor)),
            react_1.jsx(layout_1.Flex, { direction: "column", alignItems: "center", gap: 4 },
                react_1.jsx(layout_1.Flex, { justifyContent: "center", alignItems: "center", gap: 4 },
                    react_1.jsx("input", { multiple: multiple, onChange: handleChange, style: { display: 'none' }, accept: accept, type: "file", disabled: disabled }),
                    react_1.jsx(Text_1.default.Body, { color: textBodyColor },
                        react_1.jsx(Link_1.default, { color: linkColor }, "Click to upload "),
                        "or drag and drop")),
                uploadUserMessage ? (react_1.jsx(Text_1.default.Body, { size: "sm", color: textBodyColor }, uploadUserMessage)) : null))));
};
exports.default = FileUploadDropArea;
